module["exports"] = [
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "21",
  "22",
  "23",
  "24",
  "27",
  "28",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "51",
  "53",
  "54",
  "56",
  "57",
  "58"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_ZA/phone_number/area_code.js
// module id = 2787
// module chunks = 1610